import { Grid, Typography } from '@mui/material';
import { useForm } from "react-hook-form";
import { ControlledInput } from '../../components/forms/input/ControlledInput';
import { ControlledTextArea } from '../../components/forms/input/ControlledTextArea';
import { endpoints } from '../../api/endpoints';
import { ModalFooter } from '../../components/modal/ModalFooter';
import AddEditModal from '../../components/modal/Modal';
import { useEffect, useState } from 'react';
import { useCrudForm } from '../../api/useCrudForm';
import CustomSelect from '../../components/forms/select/CustomSelect';
import { toast } from 'react-toastify';
import * as Yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';

export default function AddEditLockerLocationModal({ open, setOpen, setSelectedItem, selectedItem, setTableList, refetch, showApproved, setShowApproved, setSkip, setTake }: { open: boolean, setTableList: (value: any) => void, setOpen: (value: boolean) => void, selectedItem: any, setSelectedItem: (value: any) => void, refetch: any, showApproved: string, setShowApproved: (value: string) => void, setSkip: any, setTake: any }) {
    return (
        <AddEditModal title={selectedItem ? 'Edit Locker Location' : 'Add New Locker Location'} setOpen={setOpen} setSelectedItem={setSelectedItem} open={open}>
            <GeneralInfo selectedItem={selectedItem} setSelectedItem={setSelectedItem} setOpen={setOpen} refetch={refetch} showApproved={showApproved} setShowApproved={setShowApproved} setSkip={setSkip} setTake={setTake} />
        </AddEditModal>
    );
}


const GeneralInfo = ({ setSelectedItem, selectedItem, setOpen, refetch, showApproved, setShowApproved, setSkip, setTake }: { setSelectedItem: (value: any) => void, selectedItem: any, setOpen: (value: boolean) => void, refetch: any, showApproved: string, setShowApproved: (value: string) => void, setSkip: any, setTake: any }) => {
    const { handleSubmit, control, formState: { errors, }, setValue } = useForm(
        {
            resolver: yupResolver(LockerLocationSchema),
            defaultValues: selectedItem ?? {
                branchId: 0,
                name: '',
                code: '',
                description: ''
            }
        }
    )

    const [branch, setbranch] = useState()

    const { get } = useCrudForm();

    useEffect(() => {
        get({
            endpoints: endpoints.common.getBranches,
            onSuccess: (data: any) => {
                setbranch(data?.data?.map((branch: any) => {
                    return { title: `${branch.name}`, id: branch.id }
                }))
            },
            onError: (error: any) => {
                console.log(error)
            }
        })
    }, [])

    const cancelMessage = 'Cancel current unsaved changes and go back to Locker location list?'

    const onSuccess = (values: any, id?: number) => {
        setSkip(0)
        setTake(10)
        if (values.id) {
            setShowApproved('false')
            refetch({ isMainTable: false })
            setOpen(false);
            setSelectedItem(null)
        } else {
            setShowApproved('false')
            refetch({ isMainTable: false })
            setOpen(false);
            setSelectedItem(null)
        }
    }

    const onError = (err: any) => {
        toast.error(err)
        setOpen(false);
        setSelectedItem(null)
    }

    const handleClose = () => {
        setOpen(false);
        setSelectedItem(null)
    };

    return (
        <>
            <Typography component={'p'} mt={2} mb={2}>General Information</Typography>
            <Grid container spacing={2}>
                <Grid item xs={6} >
                    <CustomSelect
                        label="Branch"
                        name="branchId"
                        errors={errors?.branchId?.message}
                        control={control}
                        values={branch ?? []}
                        size={12}
                        setValue={setValue}
                        labelName="branchName"
                    />
                </Grid>
                <Grid item xs={6} >
                    <ControlledInput name="name" control={control} errors={errors} label="Name" />
                </Grid>
                <Grid item xs={6} >
                    <ControlledInput name="code" control={control} errors={errors} label="Code" />
                </Grid>
                <Grid item xs={12} >
                    <ControlledTextArea name="description" control={control} errors={errors} label="Description" />
                </Grid>

            </Grid>
            <ModalFooter endpoint={endpoints.lockerLocation.add} editEndpoint={endpoints.lockerLocation.edit} onSuccess={onSuccess} handleSubmit={handleSubmit} handleModalClose={handleClose} selectedItem={selectedItem} cancelMessage={cancelMessage} onError={onError} />
        </>
    )
}

export const LockerLocationSchema = Yup.object().shape({
    branchId: Yup.number().required('Required').notOneOf([0], 'Required'),
    name: Yup.string().required("Name Required"),
    code: Yup.string().min(2, "code Required"),
    description: Yup.string(),
});